<template>
  <div class="container">
    <input type="text" v-model="cost" placeholder="cost">
    <input type="text" v-model="grade" placeholder="grade">
    <input type="text" v-model="program" placeholder="program">
    <input type="text" v-model="sessionOne" placeholder="sessionOne">
    <input type="text" v-model="sessionTwo" placeholder="sessionTwo">
    <input type="text" v-model="sessionThree" placeholder="sessionThree">
    <input type="text" v-model="subject" placeholder="subject">
    <input type="text" v-model="title" placeholder="title">
    <input type="text" v-model="time" placeholder="time">
    <input type="text" v-model="unit" placeholder="unit">
    <input type="text" v-model="location" placeholder="location">
    <input type="checkbox" value="true" v-model="active">

    <button type="button" @click.prevent="addTraining">Add Training</button>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')

export default {
  data() {
    return {
      cost: '',
      grade: '',
      program: '',
      sessionOne: '',
      sessionTwo: '',
      sessionThree: '',
      subject: '',
      title: '',
      time: '',
      unit: '',
      location: '',
      active: true
    }
  },
  methods: {
    addTraining() {
      fb.trainingSessionsCollection.add({
        cost: this.cost,
        grade: this.grade,
        program: this.program,
        sessionOne: this.sessionOne,
        sessionTwo: this.sessionTwo,
        sessionThree: this.sessionThree,
        subject: this.subject,
        title: this.title,
        time: this.time,
        unit: this.unit,
        location: this.location,
        active: this.active
      }).then(() => {
        this.cost = ''
        this.grade = ''
        this.sessionOne = ''
        this.sessionTwo = ''
        this.sessionThree = ''
        this.subject = ''
        this.title = ''
        this.time = ''
        this.unit = ''
        this.location = ''
        this.active = true
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
